export default "__VITE_ASSET__BTIUjSTz__"